import { useState } from 'react';

function YearPicker({ startYear = 2000, endYear = new Date().getFullYear() }) {
  const [year, setYear] = useState(endYear);

  return (
    <select value={year} onChange={(e) => setYear(Number(e.target.value))}>
      {Array.from({ length: endYear - startYear + 1 }, (_, i) => startYear + i).map((y) => (
        <option key={y} value={y}>{y}</option>
      ))}
    </select>
  );
}
export default YearPicker;